import { InterpolateElement } from '../components/Interpolate';

import { i18nType } from './useTranslation';

export function stringify(this: i18nType, value: string | InterpolateElement) {
  return typeof value === 'string' ? value : this.t(value.props.i18nKey, value.props.values);
}
